
<!--Name-->
<div class="grid field col-12">
  <div class="p-inputgroup">
    <span class="p-inputgroup-addon">Name</span>
    <input type="text" pInputText placeholder="Enter Name" [(ngModel)]="address.name" required="true" />
  </div>
  @if (displayModelInvalid && !address.name) {
    <div class="grid field col-12">
      <label style="color:red; font-weight:bold;">Name is required!</label>
    </div>
  }
</div>

<!--Phone-->
<div class="grid field col-12">

  <div class="p-inputgroup">
    <span class="p-inputgroup-addon">
      <i class="fa fa-phone"></i>
    </span>
    <p-inputMask mask="(999) 999-9999"
    placeholder="(999) 999-9999" [(ngModel)]="address.phone" ></p-inputMask>
  </div>
  @if (displayModelInvalid && !address.phone) {
    <div class="grid field col-12">
      <label style="color:red; font-weight:bold;">Phone is required!</label>
    </div>
  }
</div>
<!--Email-->
<div class="grid field col-12">
  <div class="p-inputgroup">
    <span class="p-inputgroup-addon">
      <i class="far fa-envelope"></i>
    </span>
    <input type="email" pInputText placeholder="Enter Email Address" [(ngModel)]="address.email"
      (input)="validateEmails()" required="true" />
    </div>
    @if (displayModelInvalid && !address.email || !emailInputValid) {
      <div class="grid field col-12">
        <label style="color:red; font-weight:bold;">A Valid Email is required!</label>
      </div>
    }
  </div>
  <!--Street-->
  <div class="grid field col-12">
    <div class="p-inputgroup">
      <span class="p-inputgroup-addon">Street</span>
      <input type="text" pInputText placeholder="Enter Street Address" [(ngModel)]="address.street" required="true" />
    </div>
    @if (displayModelInvalid && !address.street) {
      <div class="grid field col-12">
        <label style="color:red; font-weight:bold;">Street Address is required!</label>
      </div>
    }
  </div>
  <!--City-->
  <div class="grid field col-12">
    <div class="p-inputgroup">
      <span class="p-inputgroup-addon">City</span>
      <input type="text" pInputText placeholder="Enter City" [(ngModel)]="address.city" required="true" />
    </div>
    @if (displayModelInvalid && !address.city) {
      <div class="grid field col-12">
        <label style="color:red; font-weight:bold;">City is required!</label>
      </div>
    }
  </div>
  <!--State-->
  <div class="grid field col-12">
    <div class="p-inputgroup">
      <span class="p-inputgroup-addon">State</span>
      <input type="text" pInputText placeholder="Enter State" [(ngModel)]="address.state" required="true" />
    </div>
    @if (displayModelInvalid && !address.state) {
      <div class="grid field col-12">
        <label style="color:red; font-weight:bold;">State is required!</label>
      </div>
    }
  </div>
  <!--Zip-->
  <div class="grid field col-12">
    <div class="p-inputgroup">
      <span class="p-inputgroup-addon">Zip</span>
      <p-inputMask #zip mask="99999?-9999" [(ngModel)]="address.zip" required="true" (onBlur)="validateZip()" placeholder="99999-9999"></p-inputMask>
    </div>
    @if (displayModelInvalid && !address.zip) {
      <div class="grid field col-12">
        <label style="color:red; font-weight:bold;">Zip Code is required!</label>
      </div>
    }
  </div>
